module.exports = __webpack_public_path__ + "img/onthemap_instruction.787c60fb.png";